export default function ($translate) {
    return {
        KEYS: {
            USER_IMPORT: 'USER_IMPORT',
            STRUCTURE_IMPORT: 'STRUCTURE_IMPORT',
            INACTIVITY_IMPORT: 'INACTIVITY_IMPORT',
            WP_SYNC: 'WP_SYNC'
        },
        LABELS: {
            USER_IMPORT: $translate.instant('integrationLog.User import'),
            STRUCTURE_IMPORT: $translate.instant('integrationLog.Structure import'),
            INACTIVITY_IMPORT: $translate.instant('integrationLog.Inactivity import'),
            WP_SYNC: $translate.instant('integrationLog.User sync')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/integrationlog/type/index.js